import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'
import Tippy from '@tippy.js/react'
import axios from 'axios'
import Clipboard from 'react-clipboard.js'
import { createSlug } from 'utils/common'

import { Icon, ButtonGroup, Button, FlexContainer, Tooltip } from 'components'

import './blockActions.scss'

class BlockActions extends PureComponent {
	state = {
		submenuIsOpen: false,
	}

	blockActions = React.createRef()

	onCreate = tippy => {
		this.tippy = tippy
	}

	showTippy = () => {
		this.tippy.show()
	}

	closeTippy = () => {
		this.tippy.hide()
	}

	addBlock = (e, { editor, node, parent }) => {
		e.preventDefault()
		e.stopPropagation()

		const index =
			editor.value.document.nodes.findIndex(n => n.key === node.key) + 1
		const isVoid = editor.isVoid(editor.value.document.nodes.get(index - 1))

		editor
			.insertNodeByKey(parent.key, index, {
				object: 'block',
				type: 'paragraph',
			})
			.moveToStartOfNode(editor.value.document.nodes.get(index))
			.focus()
	}

	removeBlock = (e, { editor, node }) => {
		editor.removeNodeByKey(node.key)
	}

	download = (id, name) => {
		axios({
			url: `files/${id}`,
			method: 'GET',
			responseType: 'blob',
		})
			.then(response => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				)
				const link = document.createElement('a')

				link.href = url
				link.setAttribute('download', name)
				link.click()

				window.URL.revokeObjectURL(url)
			})
			.catch(error => console.log(error))
	}

	renderActionMenu = ({ editor, node }) => {
		const dynamicButtons = []
		const { t } = this.props

		switch (node.type) {
			case 'hint':
				dynamicButtons.push(
					{
						label: t('editor.hint_info_label'),
						icon: 'info',
						colorTheme: 'info',
						onClick: () => {
							editor.setNodeByKey(node.key, {
								type: 'hint',
								data: {
									theme: 'info',
								},
							})
						},
					},
					{
						label: t('editor.hint_warning_label'),
						icon: 'warning',
						colorTheme: 'warning',
						onClick: () => {
							editor.setNodeByKey(node.key, {
								type: 'hint',
								data: {
									theme: 'warning',
								},
							})
						},
					},
					{
						label: t('editor.hint_success_label'),
						icon: 'success',
						colorTheme: 'success',
						onClick: () => {
							editor.setNodeByKey(node.key, {
								type: 'hint',
								data: {
									theme: 'success',
								},
							})
						},
					}
				)

				break
			case 'image':
			case 'file':
				if (node.data.get('url')) break

				dynamicButtons.push({
					label: t('download'),
					icon: 'download',
					onClick: () => {
						this.download(
							node.data.get('id'),
							node.data.get('name')
						)
					},
				})

				break
			default:
		}

		return (
			<>
				{dynamicButtons.map((button, index) => (
					<Button
						key={`button-${index}`}
						icon={<Icon name={button.icon} />}
						colorTheme={button.colorTheme || null}
						text={button.label}
						layout="tertiary"
						fullWidth
						size="small"
						onMouseDown={e => {
							e.preventDefault()

							button.onClick()

							this.closeTippy()
						}}
					/>
				))}

				{!!dynamicButtons.length && (
					<hr className="o-button-group__divider" />
				)}

				{(node.type === 'heading-two' ||
					node.type === 'heading-three') && (
					<Clipboard
						type="button"
						className="o-button o-button--tertiary o-button--small o-button--full-width has-icon is-visible"
						data-clipboard-text={`${
							window.location.href
						}#${createSlug(node.text)}`}
						onSuccess={() => this.closeTippy()}
					>
						<span className="o-button__icon">
							<svg className="o-icon o-icon--rte_link">
								<use xlinkHref="#icon--rte_link" />
							</svg>
						</span>
						<span className="o-button__text">
							<span>{t('editor.copy_section_link')}</span>
						</span>
					</Clipboard>
				)}
				<Button
					icon={<Icon name="delete" />}
					text={t('delete')}
					layout="tertiary"
					fullWidth
					size="small"
					onMouseDown={e => {
						e.preventDefault()

						if (this.props.editor.value.document.nodes.size === 1) {
							editor.insertBlock('paragraph')
						}

						this.removeBlock(e, { editor, node })
						this.closeTippy()
					}}
				/>
			</>
		)
	}

	render() {
		const { t } = this.props

		if (this.props.parent.object !== 'document') return this.props.children

		// if (
		// 	this.props.isFocused
		// 	&& this.props.parent.object === 'document'
		// 	&& this.props.node.text.length === 0
		// 	&& this.props.node.type === 'paragraph'
		// 	&& window.getSelection().isCollapsed
		// ) return <div {...this.props.attributes} className={`o-editor__section o-editor__section--${this.props.node.type}`}>{this.props.children}</div>

		return (
			<div
				{...this.props.attributes}
				className={`o-editor__section o-editor__section--${this.props.node.type}`}
				ref={this.blockActions}
			>
				{!this.props.editor.readOnly && (
					<div
						className={
							this.state.submenuIsOpen
								? 'c-block-actions c-block-actions--show'
								: 'c-block-actions'
						}
					>
						<FlexContainer
							alignItems="flex-end"
							justifyContent="center"
							noSpaceBetweenChilds
						>
							<Tooltip title={t('editor.click_to_add_block')}>
								<Button
									icon={<Icon name="add" />}
									tabIndex="-1"
									onMouseDown={e =>
										this.addBlock(e, this.props)
									}
								/>
							</Tooltip>
							<Tooltip title={t('editor.click_for_options')}>
								<Tippy
									// appendTo={this.blockActions.current}
									placement="right-start"
									trigger="manual"
									animation="shift-away"
									animateFill={false}
									theme="min-width-small"
									// hideOnClick={false}
									interactive={false}
									a11y={false}
									delay={150}
									onCreate={this.onCreate}
									onShown={() => {
										this.setState({ submenuIsOpen: true })
									}}
									onHidden={() => {
										this.setState({ submenuIsOpen: false })
									}}
									content={
										<ButtonGroup>
											{this.renderActionMenu(this.props)}
										</ButtonGroup>
									}
								>
									<Button
										icon={<Icon name="dot-3" />}
										onClick={e => {
											e.preventDefault()
											e.stopPropagation()

											this.props.editor.blur()

											if (this.state.submenuIsOpen) {
												this.closeTippy()
											} else {
												this.showTippy()
											}
										}}
									/>
								</Tippy>
							</Tooltip>
						</FlexContainer>
					</div>
				)}
				{this.props.children}
			</div>
		)
	}
}

export default translate()(BlockActions)
